const TITLE_SUFFIX = "WineAPI";

export function pageTitle(label: string) {
  return `${label} · ${TITLE_SUFFIX}`;
}

export function getLoginTitle({ sent, error }: { sent: boolean; error: string }) {
  if (sent) return pageTitle("Check your email");
  if (error) return pageTitle("Sign in");
  return pageTitle("Sign in");
}

export function getVerifyTitle(error: string | null) {
  return pageTitle(error ? "Verification failed" : "Verifying your login");
}

export function getBillingResultTitle(result: "success" | "cancel") {
  return pageTitle(result === "success" ? "Checkout complete" : "Checkout cancelled");
}

export function getSubmissionTitle(success: boolean) {
  return pageTitle(success ? "Submission received" : "Submit a Wine");
}

export function getPostmortemTitle(title?: string | null) {
  return pageTitle(title ?? "Postmortem");
}

function normalizePathname(pathname: string) {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

export function getStaticRouteTitle(pathname: string) {
  const path = normalizePathname(pathname);

  if (path === "/") return pageTitle("Wine intelligence");
  if (path === "/login") return pageTitle("Sign in");
  if (path === "/verify") return pageTitle("Verify login");
  if (path === "/contact-enterprise") return pageTitle("Contact enterprise");
  if (path === "/terms") return pageTitle("Terms of service");
  if (path === "/privacy") return pageTitle("Privacy policy");
  if (path === "/mcp-setup") return pageTitle("MCP setup");
  if (path === "/data-coverage") return pageTitle("Data Coverage & FAQ");
  if (path === "/billing/success") return pageTitle("Checkout complete");
  if (path === "/billing/cancel") return pageTitle("Checkout cancelled");
  if (path === "/dashboard") return pageTitle("Dashboard");
  if (path === "/dashboard/keys") return pageTitle("API keys");
  if (path === "/dashboard/billing") return pageTitle("Billing");
  if (path === "/dashboard/submissions/new") return pageTitle("Submit a Wine");
  if (path === "/dashboard/support") return pageTitle("Priority support");
  if (path === "/admin") return pageTitle("Users");
  if (path === "/admin/abuse") return pageTitle("Abuse review");
  if (path.startsWith("/admin/users/")) return pageTitle("User details");
  if (path === "/admin/subscriptions") return pageTitle("Subscriptions");
  if (path === "/admin/usage") return pageTitle("Usage");
  if (path === "/admin/logs") return pageTitle("Logs");
  if (path === "/admin/enterprise") return pageTitle("Enterprise");
  if (path === "/admin/wine-health") return pageTitle("Wine health");
  if (path === "/admin/provider-status") return pageTitle("Provider status");
  if (path === "/admin/api-tests") return pageTitle("API tests");
  if (path === "/postmortem" || path.startsWith("/postmortem/")) {
    return pageTitle("Postmortem");
  }

  return null;
}
